import React from "react";
import { StoryblokPage } from "@/components/StoryblokPage";

// Paginile legale nu mai trec prin React: sunt doar cele statice din public/<pagină>/, generate din
// legal/*.md cu scripts/build-legal.mjs. Adresele vechi /ro/<pagină> le redirecționează server.js.
function App(): React.ReactElement {
  return <StoryblokPage />;
}

export default App;
